import { render, staticRenderFns } from "./TextareaWrapper.vue?vue&type=template&id=2ead675d&"
import script from "./TextareaWrapper.vue?vue&type=script&lang=js&"
export * from "./TextareaWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ead675d')) {
      api.createRecord('2ead675d', component.options)
    } else {
      api.reload('2ead675d', component.options)
    }
    module.hot.accept("./TextareaWrapper.vue?vue&type=template&id=2ead675d&", function () {
      api.rerender('2ead675d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/TextareaWrapper.vue"
export default component.exports